import { Container, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useFormContext } from "react-hook-form";
import { FirstStepFormData } from "../../../schemas/validationSchemas";
import { FormTextField, FormButtonGroup } from "../../common";

export const UserForm = () => {
  const { control } = useFormContext<FirstStepFormData>();

  return (
    <Container>
      <Grid2
        container
        my={5}
        spacing={4}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid2 container spacing={4} sx={{ width: "100%" }}>
          <Grid2 xs={6}>
            <FormTextField
              name="user"
              control={control}
              label="Name"
              placeholder="Your name"
              focused
              sx={{ width: "100%" }}
            />
          </Grid2>

          
          <Grid2 xs={6}>
            <FormTextField
              name="email"
              control={control}
              label="Email"
              placeholder="Your email"
              type="email"
              focused
              sx={{ width: "100%" }}
            />
          </Grid2>

          
          <Grid2 xs={6} sx={{ display: "flex", alignItems: "flex-end" }}>
            <Typography fontWeight="bold" variant="body1">
              Are you using this heat pump calculator for:
            </Typography>
          </Grid2>

          
          <Grid2 xs={6} sx={{ display: "flex", alignItems: "flex-end" }}>
            <FormButtonGroup
              name="isExistingPool"
              control={control}
              options={[
                { value: true, label: "EXISTING POOL" },
                { value: false, label: "NEW POOL" },
              ]}
              direction="row"
              gap={2}
              containerSx={{
                width: "100%",
              }}
              required
            />
          </Grid2>
        </Grid2>
      </Grid2>
    </Container>
  );
};
